import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, LoadingController, NavParams, Item } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Sadhona } from '../../providers/sadhona'
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';

@IonicPage()
@Component({
    selector: 'page-enter-sadhona',
    templateUrl: 'sadhona-form.html',
})
export class SadhonaFormPage {
    @ViewChild('datePicker') datePicker;
    sadhonaForm: FormGroup
    dataInicial: any;
    maxDate: any
    roundchanteds = []
    prabhupadabooks = []
    prabhupadalectures = []
    gurulectures = []
    otherslectures = []
    dailyroundsbefore10 = []
    // init wait loader
    loading: any
    saving: any
    notAlertPresented = true
    isSubmitted = false
    dateobj: any;
    popup = false;
    today = new Date()
    constructor(public navCtrl: NavController, private formBuilder: FormBuilder, private sadhona: Sadhona, private toastCtrl: ToastController,
        private alertCtrl: AlertController, public loadingCtrl: LoadingController, private storage: Storage) {

        // init wait loader
        this.loading = this.loadingCtrl.create({
            content: 'Preparing your sadhana entry'
        });
        this.saving = this.loadingCtrl.create({
            content: 'Saving sadhana entry'
        });


        this.maxDate = new Date().toJSON().split('T')[0];
        this.dataInicial = new Date().toJSON().split('T')[0];
        this.sadhonaForm = this.formBuilder.group({
            sadhonadate: [this.dataInicial],
            email: false,
            daily: this.formBuilder.group({
                roundchanted: [0, [Validators.required, Validators.pattern(/^\+?\d+$/)]],
                inputroundchanted: ['', [Validators.pattern(/^\+?\d+$/)]],
                roundbefore10am: [0, [Validators.required, Validators.pattern(/^\+?\d+$/)]],
                inputroundbefore10am: ['', [Validators.pattern(/^\+?\d+$/)]],
                wokeupbefore6am: [false, []],
                prabhupadabook: [0, [Validators.required, Validators.pattern(/^\+?\d+$/)]],
                inputprabhupadabook: ['', [Validators.pattern(/^\+?\d+$/)]],
                lecturebysp: [0, [Validators.required, Validators.pattern(/^\+?\d+$/)]],
                inputlecturebysp: ['', [Validators.pattern(/^\+?\d+$/)]],
                lecturebyguru: [0, [Validators.required, Validators.pattern(/^\+?\d+$/)]],
                inputlecturebyguru: ['', [Validators.pattern(/^\+?\d+$/)]],
                lecturebyother: [0, [Validators.required, Validators.pattern(/^\+?\d+$/)]],
                inputlecturebyother: ['', [Validators.pattern(/^\+?\d+$/)]],
                aartiathome: [false, [Validators.required,]],
            }),
            weekly: this.formBuilder.group({
                serviceiskcon2week: [false, [Validators.required]],
                preaching: [false, [Validators.required]],
                menteemeeting: [false, [Validators.required]],
                festivalsunday: [false, [Validators.required]],
            }),
            monthly: this.formBuilder.group({
                morningproggramme4: [false, [Validators.required]],
                morningproggramme7: [false, [Validators.required]]
            }),
            note: ['', [Validators.maxLength(120)]]
        });
        //this.getSadhanaData()
        this.getSingleSadhonaData()
    }

    shownGroup = null;
    name = 'arrow-dropdown'
    // collapse/open form section 
    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            this.shownGroup = null;
        } else {
            this.shownGroup = group;
        }
    };
    isGroupShown(group) {
        return this.shownGroup === group;
    };

    onSubmit(value, email) {
        if (this.sadhonaForm.get('note').invalid) {
            this.presentAlert('Error', 'Note can not be more than 120 character')
            return false;
        }
        this.saving = this.loadingCtrl.create({
            content: 'Saving sadhana entry'
        });

        if (!value.sadhonadate) {
            this.presentAlert('Alert Message', 'Please select a date')
            return
        }
        if (value.daily.inputroundchanted != '') {
            value.daily.roundchanted = value.daily.inputroundchanted
        }
        if (value.daily.inputroundbefore10am != '') {
            value.daily.roundbefore10am = value.daily.inputroundbefore10am
        }
        if (value.daily.inputprabhupadabook != '') {
            value.daily.prabhupadabook = value.daily.inputprabhupadabook
        }
        if (value.daily.inputlecturebysp != '') {
            value.daily.lecturebysp = value.daily.inputlecturebysp
        }
        if (value.daily.inputlecturebyguru != '') {
            value.daily.lecturebyguru = value.daily.inputlecturebyguru
        }
        if (value.daily.inputlecturebyother != '') {
            value.daily.lecturebyother = value.daily.inputlecturebyother
        }

        if (!value.daily.wokeupbefore6am) {
            value.daily.wokeupbefore6am = false
        }
        value.email = email
        if (this.isSubmitted) {
            this.presentAlert('Alert Message', 'You can not submit entry on approved sadhana sheet')
            return false
        }
        if (navigator && !navigator.onLine) {
            this.storage.get('sadhona-offline-data-entry').then(data => {
                if (data) {
                    data.push(this.sadhonaForm.value)
                } else {
                    data = [this.sadhonaForm.value]
                }
                this.storage.set('sadhona-offline-data-entry', data);

            })
            this.presentToast('Your data is stored temporarily. It will be stored when you are online');
            return false

        }
        this.saving.present().then(() => {
            this.sadhona.insertSadhana(this.sadhonaForm.value).subscribe(
                res => {
                    this.saving.dismiss(); // hide loader
                    if (res['success']) {
                        this.presentToast(res['message'])
                        this.navCtrl.push(HomePage)
                    }
                },
                err => {
                    this.saving.dismiss(); // hide loader
                    this.presentAlert('Error', 'Please check all input')
                }
            )
        })
    }

    getSingleSadhonaData() {
        this.sadhona.getSingleSadhanaSheet(this.sadhonaForm.get('sadhonadate').value).subscribe(
            res => {
                if (res['success'] && res['data'].length > 0) {
                    let data = res['data'][0]
                    let roundchantedFound = this.checkValueExist(data.dailyrounds, this.roundchanteds)
                    let prabhupadabooksFound = this.checkValueExist(data.prabhupadabooks, this.prabhupadabooks)
                    let prabhupadalecturesFound = this.checkValueExist(data.prabhupadalectures, this.prabhupadalectures)
                    let gurulecturesFound = this.checkValueExist(data.gurulectures, this.gurulectures)
                    let otherslecturesFound = this.checkValueExist(data.otherslectures, this.otherslectures)
                    let dailyroundsbefore10Found = this.checkValueExist(data.dailyroundsbefore10, this.dailyroundsbefore10)
                    if (!roundchantedFound) {
                        this.roundchanteds.push({ val: data.dailyrounds })
                    }
                    if (!prabhupadabooksFound) {
                        this.prabhupadabooks.push({ val: data.prabhupadabooks })
                    }
                    if (!prabhupadalecturesFound) {
                        this.prabhupadalectures.push({ val: data.prabhupadalectures })
                    }
                    if (!gurulecturesFound) {
                        this.gurulectures.push({ val: data.gurulectures })
                    }
                    if (!otherslecturesFound) {
                        this.otherslectures.push({ val: data.otherslectures })
                    }
                    if (!dailyroundsbefore10Found) {
                        this.dailyroundsbefore10.push({ val: data.dailyroundsbefore10 })
                    }

                    this.sadhonaForm.get('daily.roundchanted').setValue(data.dailyrounds);
                    this.sadhonaForm.get('daily.roundbefore10am').setValue(data.dailyroundsbefore10);
                    this.sadhonaForm.get('daily.prabhupadabook').setValue(data.prabhupadabooks);
                    this.sadhonaForm.get('daily.lecturebysp').setValue(data.prabhupadalectures);
                    this.sadhonaForm.get('daily.lecturebyguru').setValue(data.gurulectures);
                    this.sadhonaForm.get('daily.lecturebyother').setValue(data.otherslectures);

                    this.sadhonaForm.get('daily.wokeupbefore6am').setValue(data.raisingbefore630);
                    this.sadhonaForm.get('daily.aartiathome').setValue(data.aartiathome);
                    this.sadhonaForm.get('weekly.serviceiskcon2week').setValue(data.servicetoiskcon);
                    this.sadhonaForm.get('weekly.preaching').setValue(data.preachingactivity);
                    this.sadhonaForm.get('weekly.menteemeeting').setValue(data.menteemeeting);
                    this.sadhonaForm.get('weekly.festivalsunday').setValue(data.festivalorsundayprogram);
                    this.sadhonaForm.get('monthly.morningproggramme4').setValue(data.morningprogramfrom430);
                    this.sadhonaForm.get('monthly.morningproggramme7').setValue(data.morningprogramfrom700);
                } else {
                    this.getSadhanaSheetOption()
                }
            }
            ,
            err => {
                console.log(' data retrive error')
            }
        )
    }

    checkValueExist(value, arrayItem) {
        if (!arrayItem) {
            return false;
        }
        let found = arrayItem.find((item) => item.val == value)
        if (found) {
            return true
        }
        return false
    }

    getSadhanaSheetOption() {
        this.loading = this.loadingCtrl.create({
            content: 'Preparing your sadhana entry'
        });
        this.loading.present().then(() => {
            this.sadhona.getSadhanaSheetOption().subscribe(
                res => {
                    let data = res['data']
                    this.roundchanteds = data[0][0].roundchanted
                    this.prabhupadabooks = data[1][0].prabhupadabooks
                    this.prabhupadalectures = data[2][0].prabhupadalectures
                    this.gurulectures = data[3][0].gurulectures
                    this.otherslectures = data[4][0].otherslectures
                    this.dailyroundsbefore10 = data[5][0].dailyroundsbefore10
                    this.sadhonaForm.get('daily.wokeupbefore6am').setValue(false);
                    this.sadhonaForm.get('daily.aartiathome').setValue(false);
                    this.sadhonaForm.get('weekly.serviceiskcon2week').setValue(false);
                    this.sadhonaForm.get('weekly.preaching').setValue(false);
                    this.sadhonaForm.get('weekly.menteemeeting').setValue(false);
                    this.sadhonaForm.get('weekly.festivalsunday').setValue(false);
                    this.sadhonaForm.get('monthly.morningproggramme4').setValue(false);
                    this.sadhonaForm.get('monthly.morningproggramme7').setValue(false);
                    this.loading.dismiss(); // hide loader
                },
                err => {
                    this.loading.dismiss(); // hide loader
                    this.presentAlert('Error', 'Can not prepare form')
                }

            )
        })
        this.getSubmittedSadhana()
    }
    clearRadio(value, event) {
        if (event.target.value != '') {
            var matches = event.target.value.match(/\d+/g);
            if (matches != null) {
                this.sadhonaForm.get('daily.' + value).setValue(parseInt(event.target.value));
            } else {
                this.presentAlert('error', 'Letter is not allowed')
                this.notAlertPresented = false
            }
        } else {
            if (this.sadhonaForm.get('daily.' + value).value === '') {
                this.presentAlert('error', 'Field can not be blank')
                this.notAlertPresented = false
            }
        }
    }

    clearInput(value) {
        this.sadhonaForm.get('daily.' + value).setValue('');
    }

    presentToast(msg) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'top',
            showCloseButton: true
        });
        toast.present();
    }

    presentAlert(title, msg) {
        if (this.notAlertPresented) {
            let alert = this.alertCtrl.create({
                title: title,
                subTitle: msg,
                buttons: [{
                    text: 'Dismiss',
                    handler: () => {
                        this.notAlertPresented = true
                    }
                }],
            });
            alert.present();
        }
    }

    getSubmittedSadhana() {
        let data = this.sadhonaForm.get('sadhonadate').value.split('-')
        let month = data[1]
        let year = data[0]
        this.sadhona.submittedSadhanaByMonth(year, month).subscribe(
            res => {
                if (res['data'].length > 0) {
                    this.isSubmitted = true
                } else {
                    this.isSubmitted = false
                }
            }
        )
    }

    togglePopup() {
        if (this.popup) {
            this.popup = false;
        } else {
            this.popup = true;
        }
    }

    OnSelectDate(value) {
        this.sadhonaForm.get('sadhonadate').setValue(value.year + '-' + value.month + '-' + value.day);
        this.popup = false
        this.getSingleSadhonaData();
        this.getSubmittedSadhana();
    }

    nextDay() {
        let date = this.sadhonaForm.value.sadhonadate;
        date = String(date).split('-');
        const year = Number(date[0])
        let month = Number(date[1])
        let day = Number(date[2])
        let nofday = (year, month) => new Date(year, month, 0).getDate();
        let finalDay: any = day + 1 > nofday(year, month) ? 1 : day + 1;
        finalDay = finalDay < 10 ? '0' + finalDay : finalDay;
        let finalMonth: any = day + 1 > nofday(year, month) ? (month + 1) : month;
        finalMonth = finalMonth === 0 ? 12 : finalMonth;
        finalMonth = finalMonth < 10 ? '0' + finalMonth : finalMonth;
        let finalYear = day + 1 > nofday(year, month) && month + 1 > 12 ? year + 1 : year;
        
        const now = new Date();
    
        if (Number(now.getFullYear()) < finalYear) {
            return false;
        }

        if (Number(now.getFullYear()) >= finalYear && (Number(now.getMonth()) + 1) < Number(finalMonth)) {
            return false;
        }
        console.log(Number(now.getMonth()) + 1, Number(finalMonth), (Number(now.getMonth()) + 1) >= Number(finalMonth))
        if (Number(now.getFullYear()) >= finalYear && (Number(now.getMonth()) + 1) == Number(finalMonth)
            && Number(now.getDate()) < Number(finalDay)) {
            return false;
        }
        
        this.OnSelectDate({year: finalYear, month: finalMonth, day: finalDay})
        
    }

    prevDay() {
        let date = this.sadhonaForm.value.sadhonadate;
        date = String(date).split('-');
        const year = Number(date[0])
        let month = Number(date[1])
        let day = Number(date[2])
        let prevMonth = day == 1 ? (month - 1) : month;
        let nofday = (year, month) => new Date(year, month, 0).getDate();
        let finalDay: any = day - 1 == 0 ? nofday(year, prevMonth)
                        : day - 1;
        finalDay = finalDay < 10 ? '0' + finalDay : finalDay;
        let finalMonth: any = day - 1 == 0 ? (month - 1) : month;
        finalMonth = finalMonth === 0 ? 12 : finalMonth;
        finalMonth = finalMonth < 10 ? '0' + finalMonth : finalMonth;
        let finalYear = day - 1 == 0 && month - 1 == 0 ? year - 1 : year;
        this.OnSelectDate({year: finalYear, month: finalMonth, day: finalDay})
    }
}



// WEBPACK FOOTER //
// ./src/pages/sadhona-form/sadhona-form.ts